import React from 'react';
import PropTypes from 'prop-types';
import './DraftOrderModal.css';
import UserImage from '../../../../assets/images/userImage.png'; // A default user image
import useModalOutsideClick from '../../hooks/useModalOutsideClick';

const DraftOrderModal = ({ isOpen, onClose, entrants }) => {
  // Add the hook to handle clicks outside the modal
  useModalOutsideClick(isOpen, onClose, 'draft-order-modal-overlay');

  if (!isOpen) {
    return null;
  }

  return (
    <div className="draft-order-modal-overlay">
      <div className="draft-order-modal-dialog">
        <div className="draft-order-modal-header">
          <h2 className="draft-order-modal-title">Official Draft Order</h2>
          <button className="draft-order-modal-close-button" onClick={onClose}>
            &times;
          </button>
        </div>
        <div className="draft-order-modal-content">
          <div className="draft-order-list">
            {entrants.map((entrant, index) => (
              <div key={entrant.userId} className="draft-order-item">
                <span className="pick-number">{index + 1}.</span>
                <img src={UserImage} alt={entrant.username} className="entrant-avatar" />
                <span className="entrant-name">{entrant.username}</span>
              </div>
            ))}
          </div>
        </div>
        <div className="draft-order-modal-actions">
            <button className="draft-order-modal-action-btn" onClick={onClose}>
              Start Drafting
            </button>
        </div>
      </div>
    </div>
  );
};

DraftOrderModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  entrants: PropTypes.arrayOf(PropTypes.shape({
    userId: PropTypes.string.isRequired,
    username: PropTypes.string.isRequired,
  })).isRequired,
};

export default DraftOrderModal; 